// Source-engine derived physics constants.
// All values are authoritative game state — this file is the "spec" that any
// future Go server MUST mirror exactly for deterministic client/server simulation.
// 1 unit = 1 inch ≈ 0.01905 m. We stay in Source units internally to match constants 1:1.

export const TICK_RATE = 100
export const TICK_INTERVAL = 1 / TICK_RATE
export const TICK_INTERVAL_MS = 1000 / TICK_RATE

// Movement — surf-server tuning
export const SV_GRAVITY = 800
export const SV_ACCELERATE = 5.5
export const SV_AIRACCELERATE = 100
export const SV_FRICTION = 4
export const SV_STOPSPEED = 80
export const SV_MAXSPEED = 320
export const SV_MAXVELOCITY = 3500
export const SV_AIRSPEED_CAP = 30 // hardcoded wishspeed cap in Source PM_AirAccelerate

// Jump impulse: vy needed to clear 45 units = sqrt(2*g*h) ≈ 268.33
export const JUMP_IMPULSE = Math.sqrt(2 * SV_GRAVITY * 45)

// Player hull (Source standing hull: 32x32x72; we approximate with a sphere for v1)
export const PLAYER_RADIUS = 18
export const PLAYER_EYE_HEIGHT = 64
export const PLAYER_STEP_HEIGHT = 18

// Surface classification
export const WALKABLE_NORMAL_Y = 0.7 // cos(~45.5°); steeper → treated as surf ramp (no friction)
export const MAX_CLIP_ITERATIONS = 4

// Camera
export const HORIZONTAL_FOV_DEG = 90

// Noclip (singleplayer-only; the server rejects noclip in MP — see Phase 2 roadmap).
export const NOCLIP_SPEED = 700
export const NOCLIP_BOOST_MULT = 3.0 // hold shift for fast traversal

// Sanity / world bounds
export const WORLD_FLOOR_Y = -4000 // below this → respawn
